module.exports = __webpack_public_path__ + "static/media/fond-Pied.9145a277.png";